export const ACTION_RESET = 'FETCH_PRESSRELEASELISTINGPAGE_RESET';
export const ACTION_REQUEST = 'FETCH_PRESSRELEASELISTINGPAGE_REQUEST';
export const ACTION_SUCCESS = 'FETCH_PRESSRELEASELISTINGPAGE_SUCCESS';
export const ACTION_ERROR = 'FETCH_PRESSRELEASELISTINGPAGE_ERROR';
